import { asyncTimeout } from 'utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from 'utils/constants';

export const getPhoneNumbers = async () => {
  await asyncTimeout(SERVICES_MOCK_DELAY);

  return ['test1', 'test2', 'test3'];
};
